module.exports = __webpack_public_path__ + "img/town.382802ad.png";